import React from 'react';
import {Col, Row} from "react-bootstrap";
import {toMoneyNotation} from "../../config/functions";
import {CalculatedOption} from "../../config/interfaces";
import {Brand} from "../../config/enums";

interface CalculationChooserProps {
    calculatedOptions: CalculatedOption[];
    chosenBrand: Brand;
    setChosenBrand: (brand: Brand) => void;
}

/**
 * Component for selecting a brand to choose and edit.
 * @param {CalculationChooserProps} props - The props that the CalculationChooser component accepts.
 * @param {CalculatedOption[]} props.calculatedOptions - Array of calculated options, every brand that is selected has one option in this array.
 * @param {Brand} props.chosenBrand - The current chosen brand.
 * @param {Function} props.setChosenBrand - Function to set the chosen brand.
 * @constructor
 */
const CalculationChooser = (props: CalculationChooserProps) => {
    const {calculatedOptions, chosenBrand, setChosenBrand} = props;

    return <Row>
        {calculatedOptions.sort((a, b) => a.brand.localeCompare(b.brand)).map(o => <Col key={o.brand + '-chooser'}>
            <div className={`brand-chooser${o.brand === chosenBrand ? ' active' : ''}`} onClick={() => setChosenBrand(o.brand)}>
                <div>
                    <img src={`/images/logo-${o.brand.toLowerCase()}.png`} alt={o.brand} />
                </div>
                <div>
                    <b style={{fontSize: 25}}>{toMoneyNotation(o.totalPriceIncl!)}</b>
                </div>
            </div>
        </Col>)}
    </Row>;
}

export default CalculationChooser;